<template>
  <div class="container">
    <a-card :loading="loading">
      <div class="header-section">
        <a-row type="flex" justify="space-between" align="middle" class="margin-bottom-20">
          <a-col>
            <h2>牧场列表</h2>
          </a-col>
          <a-col>
            <a-button type="primary" icon="plus" @click="handleAdd" v-if="[1,2].includes(info.role_id)">新增牧场</a-button>
          </a-col>
        </a-row>
      </div>

      <a-table 
        :dataSource="farmList" 
        :columns="columns" 
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        rowKey="id">
        <template slot="action" slot-scope="record">
          <a-dropdown>
            <a-menu slot="overlay" @click="handleMenuClick($event, record)">
              <a-menu-item key="edit">编辑</a-menu-item>
              <a-menu-item key="view">查看</a-menu-item>
              <a-menu-item key="delete" style="color: red;" v-if="[1,2].includes(info.role_id)">删除</a-menu-item>
            </a-menu>
            <a-button type="link">操作 <a-icon type="down" /></a-button>
          </a-dropdown>
        </template>
      </a-table>
    </a-card>

    <a-modal
      title="确认删除"
      :visible="deleteModalVisible"
      :confirm-loading="deleteModalConfirmLoading"
      @ok="handleDeleteConfirm"
      @cancel="handleModalCancel"
    >
      <p>确定要删除牧场 "{{ currentRecord && currentRecord.name }}" 吗？此操作不可恢复。</p>
      <a-form :form="form" layout="vertical">
        <a-form-item label="登录密码">
          <a-input-password v-decorator="['password', { rules: [{ required: true, message: '请输入登录密码' }] }]" />
        </a-form-item>
      </a-form>

    </a-modal>

    <add-or-edit-farm ref="addOrEditFarm" @finish-edit="refreshList"></add-or-edit-farm>
  </div>
</template>

<script>
import { mapGetters } from 'vuex/dist/vuex.common.js';
import addOrEditFarm from './components/addOrEdit.vue'
export default {
  name: 'FarmList',
  components: { addOrEditFarm },
  data() {
    return {
      loading: false,
      modalVisible: false,
      modalConfirmLoading: false,
      deleteModalVisible: false,
      deleteModalConfirmLoading: false,
      modalType: 'add', // 'add' 或 'edit'
      currentRecord: null,
      farmList: [],
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          width: 80
        },
        {
          title: '牧场名称',
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: '地址',
          dataIndex: 'location',
          key: 'location'
        },
        {
          title: '联系电话',
          dataIndex: 'phone',
          key: 'phone'
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at'
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: 200
        }
      ]
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    modalTitle() {
      return this.modalType === 'add' ? '新增牧场' : '编辑牧场';
    },
    ...mapGetters('main/user',['info']),
  },
  created() {
    this.refreshList();
  },
  methods: {
    // 获取牧场列表
    async refreshList() {
      this.loading = true;
      try {
        const params = {
          page_no: this.pagination.current,
          page_size: this.pagination.pageSize
        };
        
        // 这里调用实际的API
        const res = await this.$api.get_farms(params);
        if (res.code === 200) {
          this.farmList = res.data.list;
          // 修改分页字段适配
          this.pagination.current = res.data.page.page_no;
          this.pagination.pageSize = res.data.page.page_size;
          this.pagination.total = res.data.page.total;
          
          // 刷新 Vuex store 中的牧场列表，以便侧边栏同步更新
          this.$store.dispatch('main/farm/getFarms');
        }
      } catch (error) {
        console.error('获取牧场列表失败:', error);
        this.$message.error('获取牧场列表失败');
      } finally {
        this.loading = false;
      }
    },

    // 处理表格分页、排序等变化
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.page_size;
      this.fetchFarmList();
    },

    // 新增牧场
    handleAdd() {
      this.modalType = 'add';
      this.currentRecord = null;
      this.$refs.addOrEditFarm.open('add', null)
      this.$nextTick(() => {
        this.form.resetFields();
      });
    },

    // 编辑牧场
    handleEdit(record) {
      this.modalType = 'edit';
      this.currentRecord = { ...record };
      this.$refs.addOrEditFarm.open('edit', record);
    },

    // 查看牧场详情
    handleView(record) {
      this.$router.push(`/farms/${record.id}`);
    },

    // 显示删除确认模态框
    showDeleteModal(record) {
      this.currentRecord = record;
      this.deleteModalVisible = true;
      this.$nextTick(() => {
        this.form.resetFields();
      });
    },

    // 删除牧场
    async handleDelete(record) {
      try {
        const res = await this.$api.delete_farm(record.id);
        if (res.code === 200) {
          this.$message.success('删除成功');
          this.fetchFarmList();
        } else {
          this.$message.error(res.message || '删除失败');
        }
      } catch (error) {
        console.error('删除牧场失败:', error);
        this.$message.error('删除牧场失败');
      }
    },

    // 确认删除操作
    handleDeleteConfirm() {
      this.form.validateFields(async (err, values) => {
        if (err) return;
        
        this.deleteModalConfirmLoading = true;
        try {
          // 这里应该调用验证密码的API，验证通过后再执行删除
          // 暂时直接执行删除操作
          const res = await this.$api.delete_farm(this.currentRecord.id);
          if (res.code === 200) {
            this.$message.success('删除成功');
            this.deleteModalVisible = false;
            this.fetchFarmList();
          } else {
            this.$message.error(res.message || '删除失败');
          }
        } catch (error) {
          console.error('删除牧场失败:', error);
          this.$message.error('删除牧场失败');
        } finally {
          this.deleteModalConfirmLoading = false;
        }
      });
    },

    // 处理菜单点击事件
    handleMenuClick({ key }, record) {
      switch (key) {
        case 'edit':
          this.handleEdit(record);
          break;
        case 'view':
          this.handleView(record);
          break;
        case 'delete':
          this.showDeleteModal(record);
          break;
      }
    },

    // 弹窗确认
    handleModalOk() {
      this.form.validateFields(async (err, values) => {
        if (err) return;
        
        this.modalConfirmLoading = true;
        try {
          let res;
          const payload = {
            ...values,
            status: values.status ? 1 : 0
          };
          
          if (this.modalType === 'add') {
            res = await this.$api.create_farm(payload);
          } else {
            res = await this.$api.update_farm(this.currentRecord.id, payload);
          }
          
          if (res.code === 200) {
            this.$message.success(this.modalType === 'add' ? '新增成功' : '编辑成功');
            this.modalVisible = false;
            this.fetchFarmList();
          } else {
            this.$message.error(res.message || (this.modalType === 'add' ? '新增失败' : '编辑失败'));
          }
        } catch (error) {
          console.error(`${this.modalType === 'add' ? '新增' : '编辑'}牧场失败:`, error);
          this.$message.error(`${this.modalType === 'add' ? '新增' : '编辑'}牧场失败`);
        } finally {
          this.modalConfirmLoading = false;
        }
      });
    },

    // 弹窗取消
    handleModalCancel() {
      this.modalVisible = false;
      this.deleteModalVisible = false;
    }
  }
};
</script>

<style scoped>
.header-section {
  margin-bottom: 20px;
}

.margin-bottom-20 {
  margin-bottom: 20px;
}
</style>